import { Routes } from "@angular/router";
import { MainLayoutComponent } from "@layout/main-layout/main-layout.component";
import { PulseSurveyDetailsComponent } from "./pulse-survey-details/pulse-survey-details.component";
import { PulseSurveyIntroductionComponent } from "./pulse-survey-introduction/pulse-survey-introduction.component";
import { PulseSurveyResultComponent } from "./pulse-survey-result/pulse-survey-result.component";
import { PulseSurveySurveyComponent } from "./pulse-survey-survey/pulse-survey-survey.component";

export default [
	{
		path: "pulse-survey",
		component: MainLayoutComponent,
		children: [
			{
				path: ":surveyId",
				children: [
					{
						path: "",
						component: PulseSurveySurveyComponent,
					},
					{
						path: "introduction",
						component: PulseSurveyIntroductionComponent,
					},
					{
						path: "history",
						component: PulseSurveyDetailsComponent,
					},
					{
						path: "result",
						component: PulseSurveyResultComponent,
					},
				],
			},
		],
	},
] satisfies Routes;
